import React from 'react';

import {cx} from '../../util';

const AceAvatar = ({className = 'h-8 w-8'}) => (
  <span
    className={cx(
      'inline-flex shrink-0 items-center justify-center rounded-xl border border-indigo-700 bg-gradient-to-b from-indigo-500 to-indigo-700 text-white shadow-sm',
      className,
    )}
  >
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-[62%] w-[62%]" aria-hidden="true">
      <path d="M12 2c.9 5.4 4.6 9.1 10 10-5.4.9-9.1 4.6-10 10-.9-5.4-4.6-9.1-10-10 5.4-.9 9.1-4.6 10-10Z" />
    </svg>
  </span>
);

export default AceAvatar;
